import { createStore } from 'vuex';
import axios from 'axios';

export default createStore({
  state: () => ({
    loading: true,

    settings: null,

    modalAddOrderOpen: false,
    selectedOrder: null,

    globalAlerts: [

    ],

    user: null,
    api: process.env.VUE_APP_API_URL,
  }),
  getters: {
    isAdmin(state) {
      if (!state.user) return false;
      return state.user.root == 1;
    },
    isOperator(state) {
      if (!state.user) return false;
      return state.user.root == 2;
    },
    isCleaner(state) {
      if (!state.user) return false;
      return state.user.root == 0;
    },
  },
  mutations: {
    setModalAddOrderOpen(state, bool) {
      state.modalAddOrderOpen = bool;
    },
    setSelectedOrder(state, value) {
      state.selectedOrder = value;
    },

    setLoading(state, bool) {
      state.loading = bool;
    },
    setSettings(state, value) {
      state.settings = value;
    },
    
    addAlert(state, elem) {
      state.globalAlerts.push(elem);
      setTimeout(() => {
        const index = state.globalAlerts.findIndex(alert => alert.alert_id == elem.alert_id);
        if (index !== -1) {
          state.globalAlerts.splice(index, 1);
        }
      }, elem.timeout);
    },
    removeAlertById(state, alert_id) {
      const index = state.globalAlerts.findIndex(alert => alert.alert_id == alert_id);
      if (index !== -1) {
        state.globalAlerts.splice(index, 1);
      }
    },
    removeAlertsByType(state, type) {
      for (let i in state.globalAlerts) {
        state.globalAlerts = state.globalAlerts.filter(alert => alert.type != type);
      }
    },

    setUser(state, elem) {
      state.user = elem;
    },

  },
  actions: {
    async formatNumber(number) {
      return Number(number).toLocaleString('ru-RU');
    },
    async createAlert({ commit }, { message, type = 'main', status = 'success', timeout = 5 }) {
      const now = Date.now();
      const randomFactor = Math.floor(Math.random() * 100000);
      const alertID = now.toString() + randomFactor.toString();
      commit('addAlert', {
        alert_id: alertID,
        message: message,
        type: type,
        status: status,
        timeout: timeout * 1000,
      });
    },
    async request({ state, commit, dispatch }, data = {}, headers = {}) {
      commit('setLoading', true);
      data.entry_key = localStorage && localStorage.entry_key ? localStorage.entry_key : null;
      try {
        const config = {
          method: "POST",
          url: state.api,
          headers: {
            'Content-Type': data instanceof FormData ? 'multipart/form-data' : 'application/json',
            ...headers
          },
          data: data,
        };

        const axios_response = await axios(config);
        const response = axios_response.data;
        const status = response.status;
        const message = response.message;

        if (status == "error") {
          dispatch('createAlert', { message, type: data.action, status: 'error' });
          return false;
        }

        commit('removeAlertsByType', data.action);

        return response.data;

      } catch (error) {
        console.error(`Ошибка запроса ${state.api}:`, error);
        throw error.response?.data || error.message;
      }
    },

    async requestData({ dispatch }, data) {
      return await dispatch('request', data);
    },

    async uploadFile({ dispatch }, { file, extraData = {} }) {
      const formData = new FormData();
      formData.append('file', file);

      Object.keys(extraData).forEach((key) => {
        formData.append(key, extraData[key]);
      });

      return await dispatch('request', ['POST', formData]);
    }
  },

  namespaced: true,
})
